import React from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'

import Master from '../Components/Master';
import Loader from '../Components/Loader';

import LogoChr from "../assets/logo-chr.png"

const ENDPOINT = "me"

const styles = theme => ({

})

class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT
    }

    linkObject = (name, link, image) => {
        return <a href="#" onClick={() => this.gotoTo("/" + link)}>
            <img src={require("../../../assets/icons/" + image)} alt={name} />
            <div className="buttonrow-text">{name}</div>
        </a>
    }

    render() {
        var {
            me
        } = this.props
        if(me.isLoading) {
            return (
                <Loader />
            )
        }
        var styleLogo = {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        }

        if(me.data.gruppe !== "admin") {
            return <div style={styleLogo}><img src={LogoChr} style={{width: 300}} /></div>
        }

        return (
            <div>
                <div className="buttonrow">
                    {this.linkObject("Verwaltung", "mitarbeiter", "02_verwaltung.png")}
                    {this.linkObject("Fahrpläne", "fahrplan", "03_fahrplaene.png")}
                    {this.linkObject("Umlaufpläne", "umlaufplan", "04_umlaufplaene.png")}
                    {this.linkObject("Leitstand", "dienstplan", "05_leitstand.png")}
                </div>
                <div className="buttonrow">
                    {this.linkObject("Monatsübersicht", "monatsuebersicht", "06_hourglass.png")}
                    {this.linkObject("Zeiterfassung", "zeiterfassung", "07_clock.png")}
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Welcome.js